package hk.com.vr360_demo2.webapp.component.dialog

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.img
import web.cssom.AlignItems
import web.cssom.Background
import web.cssom.BoxShadow
import web.cssom.BoxSizing
import web.cssom.Color
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent
import web.cssom.Position
import web.cssom.ZIndex
import web.cssom.pct
import web.cssom.px
import kotlin.js.unsafeCast

external interface BaseDialogProps : Props {
    var show: Boolean
    var title: String
    var onClose: () -> Unit
    var content: react.ReactNode
}

val BaseDialog = FC<BaseDialogProps> { props ->
    if (!props.show) return@FC
    div {
        css {
            position = Position.fixed
            top = 0.px
            left = 0.px
            width = 100.pct
            height = 100.pct
            background = Color("rgba(0,0,0,0.4)")
            display = Display.flex
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center
            zIndex = 9999.unsafeCast<ZIndex>()
            asDynamic().pointerEvents = "auto"
        }
        div {
            css {
                background = Color("#fff")
                borderRadius = 12.px
                padding = 16.px
                maxWidth = 580.px
                width = 100.pct
                marginLeft = 20.px
                marginRight = 20.px
                color = Color("#222")
                boxShadow = BoxShadow(0.px, 4.px, 24.px, Color("rgba(0,0,0,0.2)"))
                display = Display.flex
                flexDirection = FlexDirection.column
                alignItems = AlignItems.stretch
                boxSizing = BoxSizing.borderBox
            }
            // 第一行：標題和關閉圖標
            div {
                css {
                    display = Display.flex
                    flexDirection = FlexDirection.row
                    alignItems = AlignItems.center
                    justifyContent = JustifyContent.spaceBetween
                    width = 100.pct
                }
                div {
                    css {
                        fontSize = 20.px
                        fontWeight = web.cssom.FontWeight.bold
                        color = Color("#222")
                    }
                    +props.title
                }
                button {
                    css {
                        background = "none".unsafeCast<Background>()
                        border = 0.px
                        cursor = web.cssom.Cursor.pointer
                        padding = 4.px
                        marginLeft = 12.px
                    }
                    onClick = { props.onClose() }
                    img {
                        src = "/assets/images/close.svg"
                        alt = "關閉"
                        css {
                            width = 20.px
                            height = 20.px
                            cursor = web.cssom.Cursor.pointer
                        }
                    }
                }
            }
            // 分割線
            div {
                css {
                    width = 100.pct
                    height = 1.px
                    background = Color("rgba(0,0,0,0.08)")
                    marginTop = 12.px
                    marginBottom = 8.px
                }
            }
            // 內容區
            div {
                css {
                    marginTop = 8.px
                }
                +props.content
            }
        }
    }
}
